/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_C1Inputs */

const en_guide_json_syntax_errors_c1 = /** @type {(inputs: Guide_Json_Syntax_Errors_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trailing commas, single quotes, unquoted keys`)
};

const ko_guide_json_syntax_errors_c1 = /** @type {(inputs: Guide_Json_Syntax_Errors_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤따르는 쉼표, 홑따옴표, 인용하지 않은 키`)
};

const ja_guide_json_syntax_errors_c1 = /** @type {(inputs: Guide_Json_Syntax_Errors_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`末尾のカンマ、シングルクォート、引用符のないキー`)
};

/**
* | output |
* | --- |
* | "Trailing commas, single quotes, unquoted keys" |
*
* @param {Guide_Json_Syntax_Errors_C1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_c1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_C1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_C1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_c1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_c1(inputs)
	return ja_guide_json_syntax_errors_c1(inputs)
});